import { render, staticRenderFns } from "./CompanyNotesForm.vue?vue&type=template&id=4f78fcee&scoped=true&"
import script from "./CompanyNotesForm.vue?vue&type=script&lang=js&"
export * from "./CompanyNotesForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotesForm.vue?vue&type=style&index=0&id=4f78fcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78fcee",
  null
  
)

export default component.exports